<mat-list avatar twoLine dense disableRipple>
  <mat-list-item
    *ngFor="let item of items; trackBy: trackBy"
    (tap)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    [@snFadeIn]
    [@snFadeOut]
  >
    <sn-icon mat-list-icon fontSet="fs" [fontIcon]="item.type?.icon"></sn-icon>
    <div mat-line>{{ item.name }}</div>
    <div mat-line>{{ item.fullAddress }}</div>
  </mat-list-item>
</mat-list>
